const APP_CONFIG = {
  FRONTEND_VERSION: 24,
};

export default APP_CONFIG;
